import {
  Box,
  DialogTitle,
  IconButton,
  Dialog as MuiDialog,
  Typography,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import type { DialogProps as MuiDialogProps } from '@mui/material/Dialog';

type DialogProps = MuiDialogProps & {
  title: string;
  subtitle?: string;
  dialogTestId?: string;
  closeButtonTestId?: string;
  handleClose: () => void;
};

/**
 * Props for configuring a dialog component from [MicroLibraryCoreUI](https://dev.azure.com/orcha/MicroLibraryTemplate/_git/MicroLibraryCoreUI)
 *
 * @property {string} title - The main title displayed on the dialog.
 * @property {string} [subtitle] - The text displayed in the dialog body.
 *
 */

export const Dialog = ({ ...props }: DialogProps) => {
  const {
    title,
    dialogTestId,
    closeButtonTestId,
    subtitle,
    handleClose,
    children,
    ...rest
  } = props;
  return (
    <MuiDialog
      {...rest}
      PaperProps={{
        'data-testid': dialogTestId,
      }}
    >
      <Box
        sx={{
          paddingLeft: '16px',
          paddingTop: '24px',
          paddingBottom: '24px',
          display: 'flex',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        <DialogTitle
          sx={{
            color: '#343538',
            fontWeight: '700',
            padding: 0,
            marginBlock: 0,
          }}
        >
          {title}
        </DialogTitle>
        {subtitle && (
          <Typography sx={{ color: '#6F7174', lineHeight: '1.7rem' }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      <IconButton
        aria-label="close"
        data-testid={closeButtonTestId}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: '#145885',
        }}
        title="Close Dialog"
        onClick={handleClose}
      >
        <CloseIcon />
      </IconButton>

      {children}
    </MuiDialog>
  );
};
